if (!customElements.get('bodd-featured-products')) {
    customElements.define('bodd-featured-products', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.addEventListener('click', event => {
          if (this.dataset.liveSwatches !== 'true' || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const swatch = event.target.closest('[data-featured-swatch]');
          const card = swatch?.closest('.bodd-new__card');
          if (!card || swatch.target === '_blank' || swatch.hasAttribute('download')) return;
          const state = [...card.querySelectorAll('template[data-featured-state]')].find(template => template.dataset.featuredState === swatch.dataset.featuredSwatch);
          if (!state) return;
          event.preventDefault();
          if (swatch.getAttribute('aria-current') === 'true') return;
          for (const slot of ['media', 'meta', 'price']) {
            const source = state.content.querySelector(`[data-featured-${slot}]`);
            const target = card.querySelector(`[data-featured-${slot}]`);
            if (source && target) target.replaceChildren(...source.cloneNode(true).childNodes);
          }
          card.querySelectorAll('[data-featured-swatch]').forEach(link => {
            if (link === swatch) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          card.querySelector('[data-featured-status]').textContent = swatch.getAttribute('aria-label');
        }, { signal });
        customElements.whenDefined('slideshow-component').then(() => {
          if (signal.aborted) return;
          const slideshow = this.querySelector('slideshow-component');
          if (!slideshow) return;
          const mobile = matchMedia('(max-width: 749px)');
          const slides = [...slideshow.querySelectorAll('slideshow-slide')];
          const sync = () => {
            slides.forEach(slide => {
              if (slide.getAttribute('aria-hidden') !== 'false') slide.setAttribute('aria-hidden', 'false');
            });
          };
          const updateLayout = () => {
            slideshow.disabled = !mobile.matches;
            if (!mobile.matches) slideshow.refs.scroller.scrollLeft = 0;
            sync();
          };
          this.observer = new MutationObserver(sync);
          this.observer.observe(slideshow, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
          mobile.addEventListener('change', updateLayout, { signal });
          slideshow.addEventListener('keydown', event => {
            if (!mobile.matches || event.target !== slideshow.refs.scroller || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
            event.preventDefault();
            const rtl = getComputedStyle(slideshow).direction === 'rtl';
            if ((event.key === 'ArrowRight') !== rtl) slideshow.next(event); else slideshow.previous(event);
          }, { signal });
          slideshow.addEventListener('focusin', event => {
            if (!mobile.matches) return;
            const slide = event.target.closest('slideshow-slide');
            if (slide) slideshow.select(slides.indexOf(slide), event, { animate: false });
          }, { signal });
          updateLayout();
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
